import React, { useEffect, useLayoutEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { LOGOUT_FUNCTION, SHARED_BASE_URL, setAccessTokenInMemory, ACCESS_TOKEN_MEMORY, ProductionConfig } from '../../api/api';
import style from './style.module.css';
import { useV4Storage } from './storage';
import { useSidebarStorage } from '../SideMenu/Side/sidebarStorage';

let origins = ["https://azapfy-v4.vercel.app", "http://localhost:5000", "https://homolog3-azapfy.vercel.app", "https://homologacao4-azapfy.vercel.app"]

const iframe = `
<iframe id="v4" src="${origins[3]}/app/azapfy_v4" allow="clipboard-read; clipboard-write" frameborder="0" width="100%" style="position: absolute; height: 100vh;">
</iframe>
`;



let lastPath = ""


export function getV4Iframe() {
    const v4Iframe = document.getElementById('v4');

    function sendMessage(message) {
        v4Iframe.contentWindow.postMessage(message, "*")
    }
    return {
        document: v4Iframe,
        sendMessage: sendMessage,
    };
}

function changeStyle(id, style) {
    const element = document.getElementById(id);
    if (element) {
        element.style.display = style;
    }
}

function removeIframe() {
    changeStyle("app-container", "flex")
    changeStyle("sidebar", "flex")
    changeStyle("front-v4", "none")
}

function captureSidebarInfo() {
    try {
        const proSidebar = document.querySelector('.pro-sidebar');
        const scrollContainer = document.querySelector('.pro-menu');
        const { expandedItemIds } = useSidebarStorage.getState();

        if (proSidebar) {
            const isCollapsed = proSidebar.classList.contains('collapsed');
            const scrollPosition = scrollContainer ? scrollContainer.scrollTop : 0;

            const sidebarState = {
                isCollapsed: isCollapsed,
                scrollPosition: scrollPosition,
                expandedItemIds: expandedItemIds
            };

            return sidebarState;
        } else {
            return null;
        }
    } catch (error) {
        console.error('Erro ao capturar informações da sidebar:', error);
        return null;
    }
}

function applySidebarState(sidebarInfo) {
    try {
        if (!sidebarInfo) return;

        useSidebarStorage.getState().setSidebarState(sidebarInfo);
    } catch (error) {
        console.error('Erro ao armazenar informações da sidebar:', error);
    }
}

function mensager(event, callback) {
    if (origins.includes(event.origin)) {
        if (typeof event.data === "string" && event.data) {
            const data = event.data?.split("::")
            if (data[0] === "init") {
                callback("init")
                return;
            }
            if (data[0] === "path") {
                const v4 = document.getElementById("front-v4")

                const route = data[1]
                const sidebarInfoJSON = data[2]

                if (sidebarInfoJSON) {
                    const sidebarInfo = JSON.parse(sidebarInfoJSON);
                    if (sidebarInfo) {
                        applySidebarState(sidebarInfo);
                    }
                }
                if (route === "/app/azapfy_v4") return;
                if (route === "/login") {
                    try { LOGOUT_FUNCTION() } catch { }
                    localStorage.clear()
                    v4.history.push(route) // GO ROUTE
                    window.history.replaceState("", "/#" + route, "/#" + route);
                    removeIframe()
                    return
                }
                if (!verifyV4(route.replace('/app', ''), v4.grupo, v4.modules)) {
                    // console.log("GO V3", route)
                    v4.history.push(route) // GO ROUTE
                    window.history.replaceState("", "/#" + route, "/#" + route);
                    removeIframe()
                    return
                }
                window.history.replaceState("", "/#" + route, "/#" + route);
            }
            else if (data[0] === "change_group") {
                try {
                    const grupo = JSON.parse(data[1]);
                    useV4Storage.getState().dispatch.setActivegGroup(grupo);
                }
                catch (e) {
                    console.error("change group error", e);
                }
            }
            else if (data[0] === "set_access_token") {
                setAccessTokenInMemory(data[1]);
            }
            else if (data[0] === "alternative_domain") {
                const active = Boolean(JSON.parse(data[1]));
                if (active) {
                    ProductionConfig.set("https://aplicacao.azapfy.com.br");
                }
                else {
                    ProductionConfig.reset();
                }
                window.location.reload();
            }
            else if (data[0] === "exit") {
                window.history.replaceState("", "/#" + lastPath, "/#" + lastPath);
                removeIframe()
            }
        }
    }
}

function messageCallback(callback) {
    return (event) => mensager(event, callback)
}

function listener(callback) {
    const callbackFunction = messageCallback(callback);
    window.removeEventListener('message', callbackFunction);
    window.addEventListener('message', callbackFunction);
}

const v4Groups = {
    JC: [
        "/torre_de_controle",
    ],
    JOBSON: [
        "/torre_de_controle",
        '/financeiro/titulos',
        '/financeiro/solicitacoes',
        '/financeiro/conta',
        '/financeiro/configuracao',
    ],
    JD: [
        '/financeiro/titulos',
        '/financeiro/solicitacoes',
        '/financeiro/conta',
        '/financeiro/configuracao',
    ],
    JSP: [
        '/financeiro/titulos',
        '/financeiro/solicitacoes',
        '/financeiro/conta',
        '/financeiro/configuracao',
    ],
    MARINHO: [
        '/financeiro/titulos',
        '/financeiro/solicitacoes',
        '/financeiro/conta',
        '/financeiro/configuracao',
    ],
    NAZARIA: [
        "/torre_de_controle",
        // "/documentos/devolucoes"
    ],
    TRANSFE: [
        "/torre_de_controle"
    ],
    ASA: [
        '/financeiro/titulos',
        '/financeiro/solicitacoes',
        '/financeiro/conta',
        '/financeiro/configuracao',
    ],
    AZAPFY: [
        '/financeiro/titulos',
        '/financeiro/solicitacoes',
        '/financeiro/conta',
        '/financeiro/configuracao',
        "/frotas",
        "/frotas/manutencao",
        "/frotas/pendencias",
        "/frotas/pneus",
        "/frotas/dashboard",
        "/frotas/combustivel",
        "/frotas/pneus/rodizio",
        "/torre_de_controle"
    ],
    AZAPERS: [
        '/financeiro/titulos',
        '/financeiro/solicitacoes',
        '/financeiro/conta',
        '/financeiro/configuracao',
        '/romaneios',
        '/romaneios/criar-romaneios',
        '/romaneios/editar-romaneios',
        "/frotas",
        "/frotas/manutencao",
        "/frotas/pendencias",
        "/frotas/pneus",
        "/frotas/dashboard",
        "/frotas/combustivel",
        "/frotas/pneus/rodizio",
        "/torre_de_controle"
    ],
    ASSUNCAO: [
        '/financeiro/titulos',
        '/financeiro/solicitacoes',
        '/financeiro/conta',
        '/financeiro/configuracao',
    ],
    JR: [
        '/financeiro/titulos',
        '/financeiro/solicitacoes',
        '/financeiro/conta',
        '/financeiro/configuracao',
    ],
    VDCLOG: [
        '/financeiro/titulos',
        '/financeiro/solicitacoes',
        '/financeiro/conta',
        '/financeiro/configuracao',
    ],
    TRANSPAPER: [
        '/financeiro/titulos',
        '/financeiro/solicitacoes',
        '/financeiro/conta',
        '/financeiro/configuracao',
    ],
    ALMEIDA: [
        '/financeiro/titulos',
        '/financeiro/solicitacoes',
        '/financeiro/conta',
        '/financeiro/configuracao',
    ],
    LF: [
        '/financeiro/titulos',
        '/financeiro/solicitacoes',
        '/financeiro/conta',
        '/financeiro/configuracao',
    ],
    R2B: [
        '/financeiro/titulos',
        '/financeiro/solicitacoes',
        '/financeiro/conta',
        '/financeiro/configuracao',
        "/frotas",
        "/frotas/manutencao",
        "/frotas/pendencias",
        "/frotas/pneus",
        "/frotas/dashboard",
        "/frotas/combustivel",
        "/frotas/pneus/rodizio",
    ],
}

function verifyV4(route, grupo, authv4Modules) {
    if (
        (Array.isArray(v4Groups[grupo]) && v4Groups[grupo].includes(route))
        || (authv4Modules && authv4Modules.routes[route])
        || (route === "/torre_de_controle")
        || (route === "/frete/faturas")
        || (route === "/frete/cotacao")
        || (route === "/sac/atendimento")
        || (route === "/sac/incidentes")
        || (route === "/sac/configuracoes")
        || (route === "/sac/indicadores")
        || (route === "/ferramentas/volumetria")
        || (route === "/empresas")
        || (route === "/roteirizacao/gerar")
        || (route === "/roteirizacao/processos")
        || (route === "/frotas")
        || (route === "/azapfy_v4")
        || (route === "/rotas")
        || (route === "/rotas/criar")
        || (route === "/rotas/editar")
        || (route === "/bug_report")
        || (route === "/certificados")
        || (route === "/volumetria")
        || (route === "/volumetria/sessoes")
        || (route === "/volumetria/configuracao")
        || (route === "/volumetria/volumes")
        || (route === "/ferramentas/feriados")
        || (route === "/frete/contratos")
        || (route === "/frete/contratos/criar")
        || (route === "/frete/contratos/editar")
        || (route === "/documentos/devolucoes")
        || (route === "/documentos/devolucoes/criar")
        || (route === "/documentos/devolucoes/editar")
        || (route === "/frete/taxas")
        || (route === "/frete/taxas/criar")
        || (route === "/romaneio-automatico")
        || (route === "/pendencias")
        || (route === "/protocolos")
        || (route === "/armazenamento")
        || (route === "/mdfe-new/listar")
        || (route === "/mdfe-new/editar")
        || (route === "/mdfe-new/criar")
        || (route === "/mdfe-new/configuracoes")
        || (route === "/ciot/listar")
        || (route === "/ciot/criar")
        || (route === "/ciot/configuracoes")
    ) {
        return true
    }
    return false
}

export function goToV4(module, authState) {
    if (!verifyV4(module, authState.grupo_ativo, authState.v4_modules)) return true
    const v4 = document.getElementById("front-v4")
    v4.goToV4(module)
}

export default function FrontV4({ history, location }) {

    const refV4 = useRef(null)
    const auth = useSelector((state) => state.auth);

    useLayoutEffect(() => {
        refV4.current.grupo = auth.grupo_ativo
        refV4.current.modules = auth.v4_modules
        refV4.current.history = history
        refV4.current.goToV4 = initIframe
    }, [auth])

    useEffect(() => {
        listener(callback)
    }, [])

    useEffect(() => {
        const handleURLChange = () => {
            const currentPath = window.location.pathname.replace("/app", "");
            const hash = window.location.hash.replace("#", "").replace("/app", "");
            const targetPath = hash || currentPath;

            const frontV4Element = document.getElementById("front-v4");
            const isV4Active = frontV4Element && frontV4Element.style.display !== "none";
            const shouldGoToV4 = verifyV4(targetPath, auth.grupo_ativo, auth.v4_modules)

            if (isV4Active) {
                if (shouldGoToV4) {
                    const iframe = document.getElementById('v4');
                    if (iframe) {
                        iframe.contentWindow.postMessage('set_route::/app' + targetPath, '*');
                    }
                    return
                }

                removeIframe();
                return;
            }

            if (shouldGoToV4) {
                initIframe(targetPath);
            }
        };

        window.addEventListener('hashchange', handleURLChange);

        return () => {
            window.removeEventListener('hashchange', handleURLChange);
        };
    }, [auth, history])

    function callback(msg) {
        switch (msg) {
            case "init":
                const path = location.pathname.replace("/app", "")
                if (verifyV4(path, auth.grupo_ativo, auth.v4_modules)) {
                    initIframe(path)
                }
                break;

            default:
                break;
        }
    }


    function initIframe(module) {
        lastPath = location.pathname

        const sidebarInfo = captureSidebarInfo();

        ProductionConfig.load();

        window.history.replaceState("", "/#/app" + module, "/#/app" + module);
        var iframe = document.getElementById('v4');
        // const refresh = localStorage.getItem("refresh_token")
        const access = ACCESS_TOKEN_MEMORY;
        iframe.contentWindow.postMessage(`set_auth::${JSON.stringify(auth)}`, '*');
        // iframe.contentWindow.postMessage(`set_refresh::${refresh}`, '*');
        iframe.contentWindow.postMessage(`set_access::${access}`, '*');
        iframe.contentWindow.postMessage(`set_cookie::123`, '*');
        document.cookie = "_logged=1; max-age=315360000;path=/;"
        iframe.contentWindow.postMessage('set_route::/app' + module, '*');
        iframe.contentWindow.postMessage(`set_base_url::${SHARED_BASE_URL}`, '*');

        iframe.contentWindow.postMessage(`alternative_domain::${JSON.stringify(ProductionConfig.isAlternative)}`, '*');

        if (sidebarInfo) {
            iframe.contentWindow.postMessage(`set_sidebar_state::${JSON.stringify(sidebarInfo)}`, '*');
        }

        document.getElementById("app-container").style.display = "none"
        document.getElementById("sidebar").style.display = "none"
        document.getElementById("front-v4").style.display = "flex"
    }

    return (
        <div ref={refV4} onClick={initIframe} id="front-v4" className={style.root_v4} style={{ display: 'none' }}>
            <div dangerouslySetInnerHTML={{ __html: iframe }}></div>
        </div>
    )
}
